import type {
  TypedAmountSpec,
  TypedAmountTypeOption,
} from "../typedAmountTypes";

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: "Not Included",
  hideAmount: true,
};
const NOT_DISCLOSED: TypedAmountTypeOption = {
  value: "notDisclosed",
  label: "Not Disclosed",
  hideAmount: true,
};
const NOT_OFFERED: TypedAmountTypeOption = {
  value: "notOffered",
  label: "Not Offered",
  hideAmount: true,
};
const DOLLAR_AMOUNT: TypedAmountTypeOption = {
  value: "dollarAmount",
  label: "Dollar amount",
};

const DOLLAR_OPTIONS: TypedAmountTypeOption[] = [
  DOLLAR_AMOUNT,
  { value: "dollarAmountPerPerson", label: "Dollar amount per person" },
  NOT_INCLUDED,
  NOT_DISCLOSED,
  NOT_OFFERED,
];

const INDIVIDUAL_DEDUCTIBLE_OPTIONS: TypedAmountTypeOption[] = [
  DOLLAR_AMOUNT,
  NOT_DISCLOSED,
  NOT_OFFERED,
];

const PERCENT_OPTIONS: TypedAmountTypeOption[] = [
  { value: "percentageAmount", label: "Percentage" },
  NOT_INCLUDED,
  NOT_DISCLOSED,
  NOT_OFFERED,
];

// Only `childrenOnlyToAge` carries an age; every other member states the
// limit on its own, so the Age input stays hidden for them.
const ORTHO_AGE_LIMIT_OPTIONS: TypedAmountTypeOption[] = [
  { value: "childrenOnlyToAge", label: "Children Only To Age" },
  { value: "adultAndChildren", label: "Adult And Children", hideAmount: true },
  {
    value: "childrenOnlyAgeNotDisclosed",
    label: "Children Only Age Not Disclosed",
    hideAmount: true,
  },
  { value: "notApplicable", label: "Not Applicable", hideAmount: true },
  NOT_INCLUDED,
  NOT_OFFERED,
];

const RATE_GUARANTEE_OPTIONS: TypedAmountTypeOption[] = [
  { value: "months", label: "Months" },
  { value: "years", label: "Years" },
  NOT_INCLUDED,
  NOT_OFFERED,
];

export const dentalPpoTypedAmountFields: Record<string, TypedAmountSpec> = {
  individualDeductible: {
    typeKey: "individualDeductibleType",
    amountKey: "individualDeductibleAmount",
    amountLabel: "Amount",
    typeOptions: INDIVIDUAL_DEDUCTIBLE_OPTIONS,
  },
  familyDeductible: {
    typeKey: "familyDeductibleType",
    amountKey: "familyDeductibleAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_OPTIONS,
  },
  annualMaximum: {
    typeKey: "annualMaximumType",
    amountKey: "annualMaximumAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_OPTIONS,
  },
  orthoAgeLimit: {
    typeKey: "orthoAgeLimitType",
    amountKey: "orthoAgeLimitAge",
    amountLabel: "Age",
    typeOptions: ORTHO_AGE_LIMIT_OPTIONS,
    amountMin: 1,
    amountInteger: true,
  },
  orthoMaximum: {
    typeKey: "orthoMaximumType",
    amountKey: "orthoMaximumAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_OPTIONS,
  },
  preventativeType1: {
    typeKey: "preventativeType1Type",
    amountKey: "preventativeType1Amount",
    amountLabel: "Percentage",
    typeOptions: PERCENT_OPTIONS,
  },
  basicType2: {
    typeKey: "basicType2Type",
    amountKey: "basicType2Amount",
    amountLabel: "Percentage",
    typeOptions: PERCENT_OPTIONS,
  },
  majorType3: {
    typeKey: "majorType3Type",
    amountKey: "majorType3Amount",
    amountLabel: "Percentage",
    typeOptions: PERCENT_OPTIONS,
  },
  orthoType4: {
    typeKey: "orthoType4Type",
    amountKey: "orthoType4Amount",
    amountLabel: "Percentage",
    typeOptions: PERCENT_OPTIONS,
  },
  rateGuarantee: {
    typeKey: "rateGuaranteeType",
    amountKey: "rateGuaranteeAmount",
    amountLabel: "Amount",
    typeOptions: RATE_GUARANTEE_OPTIONS,
    amountMin: 1,
    amountInteger: true,
    textExtra: {
      key: "rateGuaranteeCap",
      label: "Cap",
      maxLength: 1024,
    },
  },
};
